var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-header-nav",class:{'in-inner':_vm.innerPageShow}},[_c('header',{staticClass:"g-header-wrapper"},[_c('g-header',{on:{"showmask":_vm.showMask}})],1),_vm._v(" "),_c('nav',{staticClass:"g-nav-wrapper"},[_c('g-nav',{attrs:{"show-flag":_vm.showMaskFlag},on:{"selectItem":_vm.selectNav}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a75b512","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/headerNav/index.vue
// module id = null
// module chunks = 